// src/components/sections/AdvantagesSection.js
import React from 'react';
import { motion } from 'framer-motion';
import AdvantageCard from '../cards/AdvantageCard';
import advantagesData from '../../data/advantages';

// Animation variants for the container to orchestrate staggered animations.
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2, // Time delay between each child's animation
    },
  },
};

// Animation variants for each individual advantage card.
const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
    },
  },
};

/**
 * AdvantagesSection component displays a list of advantages with entrance animations.
 * @return {React.ReactElement} The AdvantagesSection component.
 */
const AdvantagesSection = () => {
  return (
    <section id="преимущества" className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Надежность, <span className="text-orange-500">проверенная на деле</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Работая с нами, вы получаете не просто продукцию, а уверенность в качестве, безопасности
            и своевременной поставке.
          </p>
        </motion.div>

        <motion.div
          className="grid md:grid-cols-2 lg:grid-cols-4 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {advantagesData.map((advantage, index) => (
            <AdvantageCard key={index} advantage={advantage} variants={itemVariants} />
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default AdvantagesSection;
